import React from 'react';
import {useNumberFormatSettings} from '../../../util/customHooks';
import NumberFormat from 'react-number-format';

export default function NumberFormatWrapper({
	value,
	isNumericString = true,
	displayType = 'text',
	renderText,
	type,
	...props
}) {
	const numberFormatSettings = useNumberFormatSettings();

	return (
		<NumberFormat
			value={value}
			isNumericString={isNumericString}
			displayType={displayType}
			{...numberFormatSettings}
			{...props}
		/>
	);
}
